/**
 * Error codes the api attaches to a genuine authentication failure (missing,
 * malformed or lapsed session token). Business rejections also answer 401 —
 * "company not found", "user not found" — so the status alone cannot be trusted
 * to mean the session is gone.
 */
const AUTH_ERROR_CODES = ['TOKEN_INVALID_OR_EXPIRED', 'TOKEN_MISSING_OR_INVALID'];

export function isSessionExpiredError(error) {
  const response = error?.response;
  if (!response || response.status !== 401) return false;
  return AUTH_ERROR_CODES.includes(response.data?.errorCode);
}

export default isSessionExpiredError;
